export default {
  save: "حفظ",
  "N/A": "غير متاح",
};
